import firebase from 'firebase/app';

let firebaseInitialized = false;
export function initializeFirebase() {
  if (firebaseInitialized) return;
  firebaseInitialized = true;
  const firebaseConfig = {
    apiKey: 'AIzaSyBsKRw1fZSZ65ahm9kbDUOw6DGv9N-kRpU',
    authDomain: 'enigmeta-parcitypate.firebaseapp.com',
    databaseURL: 'https://enigmeta-parcitypate.firebaseio.com',
    projectId: 'enigmeta-parcitypate',
    storageBucket: 'enigmeta-parcitypate.appspot.com',
    messagingSenderId: '250249442066',
    appId: '1:250249442066:web:98ff1dbb62485d0ff539cb',
  };
  firebase.initializeApp(firebaseConfig);
}
